module.exports = __webpack_public_path__ + "static/flags/CE-452f0cc3d68cef62b2760f1a035fc80c.gif";